import {
  OrderResponse,
  OrderResponseFromStatusV2,
  SpecialOrderTypes,
} from '../../../../shared/infra';

export const turboHelper = {
  isTurboqueue: (specialOrder: SpecialOrderTypes[]) =>
    specialOrder?.includes('turbo') ?? false,

  sortV2Callback: (a: OrderResponse, b: OrderResponse) => {
    if (a?.special_order?.includes('turbo')) {
      return -1;
    }
    if (b?.special_order?.includes('turbo')) {
      return 1;
    }
    return 0;
  },
  filterV2: (orders: OrderResponseFromStatusV2[]) => {
    return [
      ...orders.filter(order => order?.special_order?.includes('turbo')),
      ...orders.filter(order => !order?.special_order?.includes('turbo')),
    ];
  },
  sortV2AutoacceptOrders: (orders: OrderResponseFromStatusV2[]) => {
    const hasTurbo = (order: OrderResponseFromStatusV2) =>
      order.special_order?.includes('turbo');

    const newOrders = orders.filter(order => order?.isAutoAcceptNew);
    const turboSpecial = orders.filter(
      order =>
        order?.special_order?.includes('turbo') && !order?.isAutoAcceptNew,
    );
    const regularOrders = orders.filter(
      order =>
        !order?.special_order?.includes('turbo') && !order?.isAutoAcceptNew,
    );
    const sortedAutoAccepted = newOrders.sort((a, b) => {
      if (hasTurbo(a) === hasTurbo(b)) return 0;
      return hasTurbo(a) ? -1 : 1;
    });

    return [...sortedAutoAccepted, ...turboSpecial, ...regularOrders];
  },
};
